import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { authService } from 'services';
import store from 'store';

const initialState = {
  cartData1: [],
  isUserLoggedIn: !!store.get(process.env.REACT_APP_ACCESS_TOKEN_KEY || 'bIESIcg42Wb9'),
  loggedInUser: store.get('loggedInUser') || {},
  loading: false,
  // isRole: !!store.get(process.env.REACT_APP_ACCESS_TOKEN_KEY || 'bIESIcg42Wb9'),
};

export const setLoggedInUser = createAsyncThunk('setLoggedInUser', async () => {
  const response = await authService.getMe();
  store.set('loggedInUser', response);
  return response;
});

const sessionSlice = createSlice({
  name: 'session',
  initialState: initialState,
  reducers: {
    setTokenSession: (state, action) => {
      store.set(process.env.REACT_APP_ACCESS_TOKEN_KEY || 'bIESIcg42Wb9', action.payload);
      state.isUserLoggedIn = true;
    },
    // setRole: (state, action) => {
    //   store.set(process.env.REACT_APP_ACCESS_TOKEN_KEY || 'bIESIcg42Wb9', action.payload);
    //   state.isRole = true;
    // },
    destroyAuthSession: (state) => {
      store.clearAll();
      state.isUserLoggedIn = false;
      state.loggedInUser = {};
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(setLoggedInUser.fulfilled, (state, action) => {
        state.loggedInUser = action.payload;
      });
  }
});

export const { setTokenSession, destroyAuthSession } = sessionSlice.actions;

export default sessionSlice.reducer;
